(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-behavior"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');

  const formatMoney = (cents, currency, locale) =>
    new Intl.NumberFormat(locale || 'en', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value) => {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  };

  const renderCampaignPrice = (root, priceInCents, campaign) => {
    const priceWrap = root?.querySelector('.price');
    const campaignWrap = root?.querySelector('[data-campaign-price]');
    const value = root?.querySelector('[data-campaign-price-value]');
    const label = root?.querySelector('[data-campaign-price-label]');
    if (!priceWrap || !campaignWrap || !value || !label) return;
    if (!campaign?.percentage) {
      priceWrap.classList.remove('has-campaign-discount');
      campaignWrap.hidden = true;
      return;
    }
    const currency = document.documentElement.dataset.currency || window.Shopify.currency.active;
    const locale = document.documentElement.lang;
    const discountedPrice = Math.round(Number(priceInCents || 0) * (1 - campaign.percentage / 100));
    value.textContent = formatMoney(discountedPrice, currency, locale);
    const buttonPrice = root.querySelector('[data-button-price]');
    if (buttonPrice) buttonPrice.textContent = formatMoney(discountedPrice, currency, locale);
    updateArtifactShippingMeter(root.querySelector('[data-artifact-shipping-meter]'), null, discountedPrice);
    label.textContent = `${campaign.label} · ${campaign.percentage}% off`;
    campaignWrap.hidden = false;
    priceWrap.classList.add('has-campaign-discount');
    root.dataset.campaignDiscountPercentage = campaign.percentage;
    root.dataset.campaignDiscountLabel = campaign.label;
  };

  const updateCampaignPrice = (root, priceInCents) => {
    const percentage = Number(root?.dataset.campaignDiscountPercentage || 0);
    const label = root?.dataset.campaignDiscountLabel;
    renderCampaignPrice(root, priceInCents, percentage && label ? { percentage, label } : null);
  };

  const normalizePercentage = (value) => {
    const number = Number(value || 0);
    if (!number) return 0;
    return number <= 1 ? Math.round(number * 10000) / 100 : Math.round(number * 100) / 100;
  };

  const initCampaignPrice = async (root) => {
    const configNode = root.querySelector('[data-campaign-discount-config]');
    const variantSelect = root.querySelector('[data-variant-select]');
    if (!configNode) return;
    let config = {};
    try { config = JSON.parse(configNode.textContent || '{}'); } catch (error) { return; }
    const codes = config.codes || {};
    const params = new URLSearchParams(window.location.search);
    const linkedCode = [params.get('discount'), params.get('discount_code'), params.get('code')]
      .find(Boolean)?.trim().toUpperCase();
    let rememberedCode = '';
    try {
      if (linkedCode && codes[linkedCode]) window.sessionStorage.setItem('pluto-campaign-discount', linkedCode);
      rememberedCode = window.sessionStorage.getItem('pluto-campaign-discount') || '';
    } catch (error) {}
    const activeCode = linkedCode && codes[linkedCode]
      ? linkedCode
      : (codes[rememberedCode] ? rememberedCode : '');
    let cart = null;
    try {
      const route = `${window.Shopify.routes.root}cart/${activeCode ? 'update.js' : 'js'}`;
      const options = activeCode
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: activeCode }) }
        : { headers: { Accept: 'application/json' } };
      const response = await window.fetch(route, options);
      if (response.ok) cart = await response.json();
    } catch (error) {}

    let campaign = activeCode
      ? { label: activeCode, percentage: Number(codes[activeCode]) }
      : null;
    const applications = [
      ...(cart?.discount_applications || []),
      ...(cart?.cart_level_discount_applications || [])
    ];
    if (!campaign) {
      const cartCodes = [
        ...(cart?.discount_codes || []).map((entry) => entry.code),
        ...applications.map((entry) => entry.title)
      ].filter(Boolean).map((code) => String(code).toUpperCase());
      const matchedCode = cartCodes.find((code) => codes[code]);
      if (matchedCode) campaign = { label: matchedCode, percentage: Number(codes[matchedCode]) };
    }
    if (!campaign) {
      const automatic = applications.find((entry) =>
        String(entry.value_type || '').toLowerCase() === 'percentage'
        && !/(PAIR|BUNDLE|BUY\s+\d|GET\s+\d)/i.test(String(entry.title || ''))
      );
      const percentage = normalizePercentage(automatic?.value);
      if (automatic && percentage) campaign = { label: automatic.title || 'Automatic offer', percentage };
    }
    const option = variantSelect?.options[variantSelect.selectedIndex];
    const priceInCents = option?.dataset.price || root.dataset.currentVariantPrice;
    renderCampaignPrice(root, priceInCents, campaign);
  };

  const updateArtifactShippingMeter = (meter, cartTotal, variantPrice) => {
    if (!meter) return;
    const threshold = Number(meter.dataset.threshold || 0);
    if (cartTotal != null) meter.dataset.cartTotal = cartTotal;
    if (variantPrice != null) meter.dataset.variantPrice = variantPrice;
    const projectedTotal = Number(meter.dataset.cartTotal || 0) + Number(meter.dataset.variantPrice || 0);
    const remaining = Math.max(0, threshold - projectedTotal);
    const progress = threshold > 0 ? Math.min(100, (projectedTotal / threshold) * 100) : 100;
    const message = meter.querySelector('[data-artifact-shipping-message]');
    const progressBar = meter.querySelector('[data-artifact-shipping-progress]');
    const currency = document.documentElement.dataset.currency || window.Shopify.currency.active;
    const locale = document.documentElement.lang;
    if (message) {
      message.textContent = remaining > 0
        ? meter.dataset.remainingTemplate.replace('__AMOUNT__', formatMoney(remaining, currency, locale))
        : meter.dataset.unlockedMessage;
    }
    if (progressBar) progressBar.style.width = `${progress}%`;
  };

  document.querySelectorAll('[data-artifact-shipping-meter]').forEach((meter) => updateArtifactShippingMeter(meter));

  const signupOffer = document.querySelector('[data-signup-offer]');
  if (signupOffer) {
    const storageKey = 'house-of-pluto-signup-offer-v4';
    const pageFlag = '__houseOfPlutoSignupOfferShown';
    const isSuccessful = Boolean(signupOffer.querySelector('[data-signup-offer-success]'));
    let hasSeenOffer = false;
    try { hasSeenOffer = window.localStorage.getItem(storageKey) === 'seen'; } catch (error) {}
    const showSignupOffer = () => {
      if (window[pageFlag] && !isSuccessful) return;
      window[pageFlag] = true;
      signupOffer.hidden = false;
      if (typeof signupOffer.showModal === 'function' && !signupOffer.open) signupOffer.showModal();
      else signupOffer.setAttribute('open', '');
      requestAnimationFrame(() => signupOffer.classList.add('is-visible'));
      try { window.localStorage.setItem(storageKey, 'seen'); } catch (error) {}
      if (isSuccessful) signupOffer.querySelector('[data-signup-offer-success]')?.focus();
    };
    const closeSignupOffer = () => {
      signupOffer.classList.remove('is-visible');
      window.setTimeout(() => {
        if (signupOffer.open && typeof signupOffer.close === 'function') signupOffer.close();
        else signupOffer.removeAttribute('open');
        signupOffer.hidden = true;
      }, 220);
    };
    if (isSuccessful) {
      window.setTimeout(showSignupOffer, 150);
    } else if (!hasSeenOffer && !window[pageFlag]) {
      let engagementTimer;
      const showAfterEngagement = () => {
        window.clearTimeout(engagementTimer);
        document.removeEventListener('mouseout', handleExitIntent);
        showSignupOffer();
      };
      const handleExitIntent = (event) => {
        if (event.clientY <= 0 && !event.relatedTarget) showAfterEngagement();
      };
      document.addEventListener('mouseout', handleExitIntent);
      if (document.querySelector('[data-product-root]')) {
        engagementTimer = window.setTimeout(showAfterEngagement, Math.max(20000, Number(signupOffer.dataset.signupDelay || 20000)));
      }
    }
    signupOffer.querySelectorAll('[data-signup-offer-close]').forEach((button) => button.addEventListener('click', closeSignupOffer));
    signupOffer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeSignupOffer();
    });
    signupOffer.addEventListener('close', () => {
      signupOffer.classList.remove('is-visible');
      signupOffer.hidden = true;
    });
  }

  const readVariantOptions = (option) => {
    try {
      return JSON.parse(option?.dataset.options || '[]');
    } catch (error) {
      return [];
    }
  };

  const syncVariantDropdowns = (root, variantOption) => {
    if (!root || !variantOption) return;
    const values = readVariantOptions(variantOption);
    const image = variantOption.dataset.image || '';
    root.querySelectorAll('[data-option-dropdown]').forEach((dropdown) => {
      const position = Number(dropdown.dataset.optionPosition || 0);
      const value = values[position];
      if (typeof value !== 'string') return;
      dropdown.dataset.optionValue = value;
      const selectedValue = dropdown.querySelector('[data-option-selected-value]');
      if (selectedValue) selectedValue.textContent = value;
      const selectedMedia = dropdown.querySelector('[data-option-selected-media] img');
      if (selectedMedia && image) {
        selectedMedia.src = image;
        selectedMedia.alt = value;
      }
      dropdown.querySelectorAll('[data-option-choice]').forEach((choice) => {
        const selected = choice.dataset.optionValue === value;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    });
  };

  document.addEventListener('click', (event) => {
    const optionChoice = event.target.closest('[data-option-choice]');
    if (optionChoice) {
      if (optionChoice.disabled || optionChoice.getAttribute('aria-disabled') === 'true') return;
      const root = optionChoice.closest('[data-product-root]');
      const dropdown = optionChoice.closest('[data-option-dropdown]');
      const select = root?.querySelector('[data-variant-select]');
      if (root && dropdown && select) {
        dropdown.dataset.optionValue = optionChoice.dataset.optionValue || '';
        const values = Array.from(root.querySelectorAll('[data-option-dropdown]'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((item) => item.dataset.optionValue || '');
        const options = Array.from(select.options);
        let match = options.find((item) => {
          const variantValues = readVariantOptions(item);
          return variantValues.length === values.length && variantValues.every((value, index) => value === values[index]);
        });
        if (!match) {
          const changedPosition = Number(dropdown.dataset.optionPosition || 0);
          match = options.find((item) => readVariantOptions(item)[changedPosition] === optionChoice.dataset.optionValue && item.dataset.available === 'true');
        }
        if (match) {
          select.value = match.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        dropdown.removeAttribute('open');
      }
    }


    const variantOption = event.target.closest('[data-variant-option]');
    if (variantOption) {
      const root = variantOption.closest('[data-product-root]');
      const select = root && root.querySelector('[data-variant-select]');
      if (select) {
        select.value = variantOption.dataset.variantId;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const zoomTrigger = event.target.closest('[data-gallery-zoom]');
    if (zoomTrigger) {
      const lightbox = zoomTrigger.closest('[data-product-root]')?.querySelector('[data-product-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
      if (lightbox && lightboxImage && typeof lightbox.showModal === 'function') {
        lightboxImage.src = zoomTrigger.dataset.zoomSrc;
        lightboxImage.alt = zoomTrigger.dataset.zoomAlt || '';
        lightbox.showModal();
      }
    }

    const dialogOpener = event.target.closest('[data-dialog-open]');
    if (dialogOpener) {
      const dialog = document.getElementById(dialogOpener.dataset.dialogOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }

    const dialogCloser = event.target.closest('[data-dialog-close]');
    if (dialogCloser) {
      const dialog = dialogCloser.closest('dialog');
      if (dialog) dialog.close();
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper && wrapper.querySelector('input[type="number"]');
      if (!input) return;
      const change = Number(quantityButton.dataset.quantityChange);
      const minimum = Number(input.min || 1);
      input.value = Math.max(minimum, Number(input.value || minimum) + change);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const currentOutput = gallery.querySelector('[data-gallery-current]');
    let currentIndex = 0;
    let pointerStart = null;

    const moveTo = (requestedIndex) => {
      if (!track || slides.length < 2) return;
      currentIndex = (requestedIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;
      slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true'));
      thumbnails.forEach((thumbnail, index) => {
        const isActive = index === currentIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (currentOutput) currentOutput.textContent = currentIndex + 1;
      if (thumbnails[currentIndex]) thumbnails[currentIndex].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    };

    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => moveTo(currentIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveTo(currentIndex + 1));
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => moveTo(Number(thumbnail.dataset.mediaIndex))));

    gallery.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') pointerStart = event.clientX;
    });
    gallery.addEventListener('pointerup', (event) => {
      if (pointerStart == null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 45) return;
      moveTo(currentIndex + (distance < 0 ? 1 : -1));
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const mainButton = root.querySelector('[data-main-add-to-cart]');
    const stickyBar = root.querySelector('[data-sticky-product-bar]');
    if (!mainButton || !stickyBar) return;
    const updateStickyBar = () => {
      const buttonBounds = mainButton.getBoundingClientRect();
      const announcementBounds = document.querySelector('.announcement')?.getBoundingClientRect();
      const visibleTop = announcementBounds && announcementBounds.bottom > 0 ? announcementBounds.bottom : 0;
      stickyBar.classList.toggle('is-visible', buttonBounds.bottom <= visibleTop + 1);
    };
    window.addEventListener('scroll', updateStickyBar, { passive: true });
    window.addEventListener('resize', updateStickyBar, { passive: true });
    updateStickyBar();
  });

  const updateBundlePairSelection = (root, activatePair = false) => {
    const offer = root?.querySelector('[data-bundle-offer]');
    if (!offer) return;
    const productSelect = offer.querySelector('[data-bundle-product-select]');
    const pairVariant = offer.querySelector('[data-bundle-pair-variant]');
    if (!productSelect || !pairVariant) return;
    const productId = productSelect.value;
    const productOption = productSelect.options[productSelect.selectedIndex];
    let activePanel = null;

    offer.querySelectorAll('[data-bundle-product-panel]').forEach((panel) => {
      const active = panel.dataset.productId === productId;
      panel.hidden = !active;
      if (active) activePanel = panel;
    });
    if (!activePanel) return;

    let variants = [];
    try { variants = JSON.parse(activePanel.querySelector('[data-bundle-product-variants]')?.textContent || '[]'); } catch (error) { return; }
    const optionSelects = Array.from(activePanel.querySelectorAll('[data-bundle-product-option]'))
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    const selectedOptions = optionSelects.map((select) => select.value);
    let variant = optionSelects.length > 0
      ? variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]))
      : variants[0];
    if (!variant) variant = variants.find((item) => item.available) || variants[0];
    if (!variant) return;

    pairVariant.value = variant.id;
    pairVariant.dataset.price = variant.price;
    pairVariant.dataset.available = variant.available;
    const title = offer.querySelector('[data-bundle-product-title]');
    if (title) title.textContent = productOption?.dataset.title || productOption?.textContent || '';
    const thumbnail = offer.querySelector('[data-bundle-product-thumbnail] img');
    if (thumbnail && productOption?.dataset.image) {
      thumbnail.removeAttribute('srcset');
      thumbnail.removeAttribute('sizes');
      thumbnail.src = productOption.dataset.image;
      thumbnail.alt = productOption.dataset.title || '';
    }

    optionSelects.forEach((select) => {
      const label = select.closest('.product-bundle__compact-option');
      const output = label?.querySelector('[data-bundle-option-label]');
      if (output) output.textContent = select.value.replace(/^Standard \/ /, '');
      if (label) label.title = `${select.getAttribute('aria-label')}: ${select.value}`;
      if (select.dataset.isColour === 'true') {
        const image = label?.querySelector('[data-bundle-colour-image]');
        const selected = select.options[select.selectedIndex];
        if (image && selected?.dataset.image) image.src = selected.dataset.image;
      }
    });

    if (activatePair) {
      const pairChoice = offer.querySelector('[data-bundle-choice][value="pair"]');
      if (pairChoice) pairChoice.checked = true;
    }
  };

  const updateBundleOffer = (root) => {
    const offer = root?.querySelector('[data-bundle-offer]');
    if (!offer) return;
    const mainSelect = root.querySelector('[data-variant-select]');
    const mainOption = mainSelect?.options[mainSelect.selectedIndex];
    const pairSelect = offer.querySelector('[data-bundle-pair-variant]');
    const selectedChoice = offer.querySelector('[data-bundle-choice]:checked')?.value || 'single';
    const isPair = selectedChoice === 'pair';
    const currency = document.documentElement.dataset.currency || window.Shopify.currency.active;
    const locale = document.documentElement.lang;
    const mainPrice = Number(mainOption?.dataset.price || offer.dataset.mainPrice || 0);
    const pairPrice = Number(pairSelect?.dataset.price || 0);
    const originalPrice = mainPrice + pairPrice;
    const savings = Math.round(originalPrice * (Number(offer.dataset.discountPercent || 0) / 100));
    const pairPriceAfterDiscount = originalPrice - savings;
    const pairDetails = offer.querySelector('[data-bundle-config]');
    const singleOutput = offer.querySelector('[data-bundle-single-price]');
    const pairOutput = offer.querySelector('[data-bundle-pair-price]');
    const pairCompare = offer.querySelector('[data-bundle-pair-compare]');
    const savingOutput = offer.querySelector('[data-bundle-saving]');
    const mainButton = root.querySelector('[data-main-add-to-cart]');
    const buttonPrice = mainButton?.querySelector('[data-button-price]');
    const addLabel = mainButton?.querySelector('[data-add-label]');
    const acceleratedCheckout = root.querySelector('[data-accelerated-checkout]');
    const pairCheckoutNote = root.querySelector('[data-pair-checkout-note]');

    offer.querySelectorAll('[data-bundle-option]').forEach((option) => {
      option.classList.toggle('is-selected', option.querySelector('[data-bundle-choice]')?.checked === true);
    });
    if (pairDetails) {
      pairDetails.setAttribute('aria-hidden', isPair ? 'false' : 'true');
      pairDetails.inert = !isPair;
    }
    if (singleOutput) singleOutput.textContent = formatMoney(mainPrice, currency, locale);
    if (pairOutput) pairOutput.textContent = formatMoney(pairPriceAfterDiscount, currency, locale);
    if (pairCompare) pairCompare.textContent = formatMoney(originalPrice, currency, locale);
    if (savingOutput) savingOutput.textContent = offer.dataset.savingTemplate.replace('__AMOUNT__', formatMoney(savings, currency, locale));
    if (buttonPrice) buttonPrice.textContent = formatMoney(isPair ? pairPriceAfterDiscount : mainPrice, currency, locale);
    if (addLabel) addLabel.textContent = isPair ? offer.dataset.addPairLabel : offer.dataset.addSingleLabel;
    if (mainButton) {
      const mainAvailable = mainOption?.dataset.available !== 'false';
      const pairAvailable = pairSelect?.dataset.available === 'true';
      mainButton.disabled = !mainAvailable || (isPair && !pairAvailable);
    }
    if (acceleratedCheckout) acceleratedCheckout.hidden = isPair;
    if (pairCheckoutNote) pairCheckoutNote.hidden = !isPair;
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantSelect = root.querySelector('[data-variant-select]');
    const variantOption = variantSelect?.options[variantSelect.selectedIndex];
    syncVariantDropdowns(root, variantOption);
    updateBundlePairSelection(root);
    updateBundleOffer(root);
    initCampaignPrice(root);
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('[data-variant-select]');
    if (variantSelect) {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const container = variantSelect.closest('[data-product-root]');
      const price = container && container.querySelector('[data-current-price]');
      const compare = container && container.querySelector('[data-compare-price]');
      const submit = container && container.querySelector('[data-add-to-cart]');
      const stickyVariant = container && container.querySelector('[data-sticky-variant]');
      const stickyPrice = container && container.querySelector('[data-sticky-price]');
      const stickySubmit = container && container.querySelector('[data-sticky-product-bar] [data-add-to-cart]');
      const buttonPrice = container && container.querySelector('[data-button-price]');
      const selectedVariant = container && container.querySelector('[data-selected-variant]');
      const lowStockBadge = container && container.querySelector('[data-product-low-stock]');
      const variantButtons = container ? Array.from(container.querySelectorAll('[data-variant-option]')) : [];
      const currency = document.documentElement.dataset.currency || window.Shopify.currency.active;
      const locale = document.documentElement.lang;
      const formattedPrice = formatMoney(option.dataset.price, currency, locale);
      if (price) price.textContent = formattedPrice;
      updateCampaignPrice(container, option.dataset.price);
      if (buttonPrice) buttonPrice.textContent = formattedPrice;
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      if (stickyVariant) stickyVariant.value = option.value;
      syncVariantDropdowns(container, option);
      if (selectedVariant) {
        selectedVariant.textContent = option.textContent.replace(/\s+—\s+.*$/, '').trim();
        selectedVariant.classList.remove('is-updating');
        void selectedVariant.offsetWidth;
        selectedVariant.classList.add('is-updating');
      }
      if (lowStockBadge) lowStockBadge.hidden = option.dataset.lowStock !== 'true';
      variantButtons.forEach((variantButton) => {
        const isActive = variantButton.dataset.variantId === option.value;
        variantButton.classList.toggle('is-active', isActive);
        variantButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (compare) {
        compare.textContent = Number(option.dataset.compare) > Number(option.dataset.price)
          ? formatMoney(option.dataset.compare, currency, locale)
          : '';
        compare.hidden = !compare.textContent;
      }
      if (submit) {
        submit.disabled = option.dataset.available !== 'true';
        submit.querySelector('[data-add-label]').textContent = option.dataset.available === 'true'
          ? submit.dataset.availableLabel
          : submit.dataset.soldoutLabel;
      }
      if (stickySubmit) {
        stickySubmit.disabled = option.dataset.available !== 'true';
        stickySubmit.querySelector('[data-add-label]').textContent = option.dataset.available === 'true'
          ? stickySubmit.dataset.availableLabel
          : stickySubmit.dataset.soldoutLabel;
      }
      const bundleOffer = container?.querySelector('[data-bundle-offer]');
      if (bundleOffer) bundleOffer.dataset.mainPrice = option.dataset.price;
      container?.querySelectorAll('[data-upsell-card]').forEach((card) => {
        card.dataset.basePrice = option.dataset.price;
        updateUpsellVariant(card.querySelector('[data-upsell-form]'));
      });
      updateArtifactShippingMeter(container?.querySelector('[data-artifact-shipping-meter]'), null, option.dataset.price);
      updateBundleOffer(container);
    }

    const bundleChoice = event.target.closest('[data-bundle-choice]');
    const bundlePairVariant = event.target.closest('[data-bundle-pair-variant]');
    if (bundleChoice || bundlePairVariant) updateBundleOffer(event.target.closest('[data-product-root]'));

    const bundleProductControl = event.target.closest('[data-bundle-product-select], [data-bundle-product-option]');
    if (bundleProductControl) {
      const root = bundleProductControl.closest('[data-product-root]');
      updateBundlePairSelection(root, true);
      updateBundleOffer(root);
    }

    const upsellOption = event.target.closest('[data-upsell-option]');
    if (upsellOption) updateUpsellVariant(upsellOption.closest('[data-upsell-form]'));

    if (event.target.matches('[data-auto-submit]')) event.target.form.submit();
  });

  const drawer = document.getElementById('CartDrawer');
  const drawerItems = drawer && drawer.querySelector('[data-cart-items]');
  const drawerSubtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  const drawerCount = drawer && drawer.querySelector('[data-cart-count]');
  const drawerCountLabel = drawer && drawer.querySelector('[data-cart-count-label]');
  const drawerFooter = drawer && drawer.querySelector('[data-cart-footer]');
  const globalCount = document.querySelector('[data-header-cart-count]');
  const drawerShippingMessage = drawer && drawer.querySelector('[data-cart-shipping-message]');
  const drawerShippingProgress = drawer && drawer.querySelector('[data-cart-shipping-progress]');
  const drawerShippingPercentage = drawer && drawer.querySelector('[data-cart-shipping-percentage]');
  const cartTarget = document.querySelector('[data-cart-target]');
  const cartToast = document.querySelector('[data-cart-toast]');
  let activeCart = null;
  let cartToastTimer = null;
  let cartToastHideTimer = null;

  const pulseCartTarget = () => {
    if (!cartTarget) return;
    cartTarget.classList.remove('is-receiving');
    void cartTarget.offsetWidth;
    cartTarget.classList.add('is-receiving');
    window.setTimeout(() => cartTarget.classList.remove('is-receiving'), 500);
  };

  const showCartToast = (productKind, itemCount) => {
    if (!cartToast) return;
    const message = productKind === 'artifact' ? cartToast.dataset.artifactMessage : cartToast.dataset.armourMessage;
    const output = cartToast.querySelector('[data-cart-toast-message]');
    const countOutput = cartToast.querySelector('[data-cart-toast-count]');
    if (output) output.textContent = message;
    if (countOutput) {
      const countMessage = Number(itemCount) === 1 ? cartToast.dataset.itemMessage : cartToast.dataset.itemsMessage;
      countOutput.textContent = countMessage.replace('__COUNT__', itemCount);
    }
    window.clearTimeout(cartToastTimer);
    window.clearTimeout(cartToastHideTimer);
    cartToast.hidden = false;
    void cartToast.offsetWidth;
    cartToast.classList.add('is-visible');
    cartToastTimer = window.setTimeout(() => {
      cartToast.classList.remove('is-visible');
      cartToastHideTimer = window.setTimeout(() => { cartToast.hidden = true; }, 250);
    }, 3000);
  };

  const animateProductToCart = (imageUrl, sourceRect) => {
    if (!cartTarget) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!imageUrl || !sourceRect || reduceMotion) {
      pulseCartTarget();
      return;
    }

    const targetBounds = cartTarget.getBoundingClientRect();
    const targetIsVisible = targetBounds.bottom > 0 && targetBounds.top < window.innerHeight;
    const targetX = targetIsVisible ? targetBounds.left + (targetBounds.width / 2) : window.innerWidth - 30;
    const targetY = targetIsVisible ? targetBounds.top + (targetBounds.height / 2) : 28;
    const flyImage = document.createElement('img');
    const flyWidth = 72;
    const flyHeight = 88;
    const startX = Math.min(window.innerWidth - flyWidth - 8, Math.max(8, sourceRect.left + (sourceRect.width / 2) - (flyWidth / 2)));
    const startY = Math.min(window.innerHeight - flyHeight - 8, Math.max(8, sourceRect.top + (sourceRect.height / 2) - (flyHeight / 2)));
    const travelX = targetX - startX - (flyWidth / 2);
    const travelY = targetY - startY - (flyHeight / 2);

    flyImage.className = 'cart-fly-image';
    flyImage.src = imageUrl;
    flyImage.alt = '';
    flyImage.style.left = `${startX}px`;
    flyImage.style.top = `${startY}px`;
    document.body.appendChild(flyImage);

    if (typeof flyImage.animate === 'function') {
      const animation = flyImage.animate([
        { opacity: 0, transform: 'translate3d(0, 8px, 0) scale(.72)' },
        { opacity: 1, offset: .2, transform: 'translate3d(0, -28px, 0) scale(1)' },
        { opacity: .12, transform: `translate3d(${travelX}px, ${travelY}px, 0) scale(.16) rotate(8deg)` }
      ], { duration: 760, easing: 'cubic-bezier(.22,.7,.18,1)', fill: 'forwards' });
      animation.addEventListener('finish', () => flyImage.remove());
      window.setTimeout(() => flyImage.remove(), 900);
    } else {
      flyImage.remove();
    }

    window.setTimeout(pulseCartTarget, 560);
  };

  const syncUpsellVisibility = (cart, root = document) => {
    if (!cart || !Array.isArray(cart.items)) return;
    activeCart = cart;
    const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));

    root.querySelectorAll('[data-upsell-region]').forEach((region) => {
      const limit = Math.max(1, Number(region.dataset.upsellLimit || 1));
      const requiresCart = region.hasAttribute('data-upsell-requires-cart');
      const seenProductIds = new Set();
      let visibleCount = 0;

      region.querySelectorAll('[data-upsell-card]').forEach((card) => {
        const productId = String(card.dataset.productId || '');
        const isEligible = Boolean(productId)
          && !cartProductIds.has(productId)
          && !seenProductIds.has(productId)
          && visibleCount < limit
          && (!requiresCart || cart.items.length > 0);

        card.hidden = !isEligible;
        if (productId) seenProductIds.add(productId);
        if (isEligible) visibleCount += 1;
      });

      region.hidden = visibleCount === 0;
    });
  };

  const updateUpsellVariant = (form) => {
    if (!form) return;
    const variantData = form.querySelector('[data-upsell-variants]');
    const selects = Array.from(form.querySelectorAll('[data-upsell-option]'));
    if (!variantData) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }
    const variantInput = form.querySelector('[data-upsell-variant-id]');
    const selectedOptions = selects
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((select) => select.value);
    const variant = selects.length > 0
      ? variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]))
      : variants.find((item) => String(item.id) === variantInput?.value) || variants[0];
    const card = form.closest('[data-upsell-card]');
    const price = card?.querySelector('[data-upsell-price]');
    const button = form.querySelector('[data-add-to-cart]');
    const currency = document.documentElement.dataset.currency || window.Shopify.currency.active;
    const locale = document.documentElement.lang;

    selects.forEach((select) => {
      const label = select.closest('.upsell-card__option');
      const output = label?.querySelector('[data-upsell-option-label]');
      if (output) output.textContent = select.value.replace(/^Standard \/ /, '');
      if (label) label.title = `${select.getAttribute('aria-label')}: ${select.value}`;
      if (select.dataset.isColour === 'true') {
        const image = label?.querySelector('[data-upsell-colour-image]');
        const selected = select.options[select.selectedIndex];
        if (image && selected?.dataset.image) image.src = selected.dataset.image;
      }
    });

    if (variantInput && variant) variantInput.value = variant.id;
    if (price && variant) {
      const combinedPrice = Number(card?.dataset.basePrice || 0) + Number(variant.price || 0);
      price.textContent = formatMoney(combinedPrice, currency, locale);
    }
    if (button) {
      const available = Boolean(variant?.available);
      button.disabled = !available;
      const buttonLabel = button.querySelector('[data-add-label]');
      if (buttonLabel) buttonLabel.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.themeRoutes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };

  document.querySelectorAll('[data-product-recommendations]').forEach(async (recommendations) => {
    try {
      const response = await fetch(recommendations.dataset.url);
      if (!response.ok) throw new Error('recommendations');
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (!replacement || !replacement.innerHTML.trim()) {
        recommendations.hidden = true;
        return;
      }
      recommendations.innerHTML = replacement.innerHTML;
      const cart = activeCart || await fetchCart();
      syncUpsellVisibility(cart, recommendations);
    } catch (error) {
      recommendations.hidden = true;
    }
  });

  fetchCart().then((cart) => syncUpsellVisibility(cart)).catch(() => {});

  const renderCart = (cart) => {
    syncUpsellVisibility(cart);
    document.querySelectorAll('[data-artifact-shipping-meter]').forEach((meter) => updateArtifactShippingMeter(meter, cart.total_price));
    if (!drawer || !drawerItems) return;
    const currency = drawer.dataset.currency;
    const locale = document.documentElement.lang;
    const emptyText = drawer.dataset.emptyText;
    drawerItems.innerHTML = cart.items.length
      ? cart.items.map((item) => `
          <article class="cart-drawer__item" data-cart-line="${escapeHtml(item.key)}">
            <a class="cart-drawer__item-media" href="${escapeHtml(item.url)}">
              ${item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="180" height="225">` : ''}
            </a>
            <div class="cart-drawer__item-content">
              <div>
                <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer__item-meta">${escapeHtml(item.variant_title)}</div>` : ''}
              </div>
              <div class="cart-drawer__item-bottom">
                <div class="cart-drawer__quantity" aria-label="${escapeHtml(drawer.dataset.quantityText)}">
                  <button type="button" data-cart-quantity-change="-1" data-cart-line-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(drawer.dataset.decreaseText)}">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-cart-quantity-change="1" data-cart-line-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(drawer.dataset.increaseText)}">+</button>
                </div>
                <strong>${formatMoney(item.final_line_price, currency, locale)}</strong>
              </div>
            </div>
          </article>`).join('')
      : `<div class="empty-state cart-drawer__empty"><span class="cart-drawer__empty-mark" aria-hidden="true">♇</span><h2>${escapeHtml(emptyText)}</h2><a class="button" href="${escapeHtml(drawer.dataset.shopUrl)}">${escapeHtml(drawer.dataset.continueText)}</a></div>`;
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price, currency, locale);
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (drawerCountLabel) drawerCountLabel.textContent = cart.item_count === 1 ? drawer.dataset.itemLabel : drawer.dataset.itemsLabel;
    if (drawerFooter) drawerFooter.hidden = cart.item_count === 0;
    if (globalCount) {
      globalCount.textContent = cart.item_count;
      globalCount.hidden = cart.item_count === 0;
    }
    const threshold = Number(drawer.dataset.freeShippingThreshold || 0);
    const remaining = Math.max(0, threshold - cart.total_price);
    const progress = threshold > 0 ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
    if (drawerShippingProgress) drawerShippingProgress.style.width = `${progress}%`;
    if (drawerShippingPercentage) drawerShippingPercentage.textContent = `${Math.round(progress)}%`;
    if (drawerShippingMessage) {
      drawerShippingMessage.textContent = remaining > 0
        ? drawer.dataset.freeShippingRemaining.replace('__AMOUNT__', formatMoney(remaining, currency, locale))
        : drawer.dataset.freeShippingUnlocked;
    }
  };

  document.addEventListener('click', async (event) => {
    const cartQuantityButton = event.target.closest('[data-cart-quantity-change]');
    if (!cartQuantityButton || !window.fetch || !drawer) return;
    const line = cartQuantityButton.closest('[data-cart-line]');
    const currentQuantity = Number(line?.querySelector('.cart-drawer__quantity span')?.textContent || 0);
    cartQuantityButton.disabled = true;
    try {
      const response = await fetch(`${window.themeRoutes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: cartQuantityButton.dataset.cartLineKey, quantity: Math.max(0, currentQuantity + Number(cartQuantityButton.dataset.cartQuantityChange)) })
      });
      if (!response.ok) throw new Error('cart');
      renderCart(await response.json());
    } finally {
      cartQuantityButton.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch || !drawer) return;
    event.preventDefault();
    const button = form.querySelector('[data-add-to-cart]');
    const productRoot = form.closest('[data-product-root]');
    const pairing = productRoot?.querySelector('[data-pairing-dialog]');
    const popup = form.closest('[data-pairing-dialog]');
    const isPrimaryProductAdd = Boolean(productRoot && !form.closest('[data-upsell-card]'));
    const bundleOffer = isPrimaryProductAdd ? productRoot.querySelector('[data-bundle-offer]') : null;
    const isPair = bundleOffer?.querySelector('[data-bundle-choice]:checked')?.value === 'pair';
    const addContext = form.closest('[data-add-context]');
    const sourceImage = form.querySelector('img') || addContext?.querySelector('img');
    const sourceBounds = sourceImage?.getBoundingClientRect();
    const sourceRect = sourceBounds ? { left: sourceBounds.left, top: sourceBounds.top, width: sourceBounds.width, height: sourceBounds.height } : null;
    const sourceUrl = sourceImage?.currentSrc || sourceImage?.src || addContext?.dataset.productImage || '';
    const productKind = addContext?.dataset.productKind || 'armour';
    if (button) button.disabled = true;
    try {
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const pairVariantId = bundleOffer?.querySelector('[data-bundle-pair-variant]')?.value;
      const requestHeaders = { Accept: 'application/json' };
      let requestBody = formData;
      if (isPair && mainVariantId && pairVariantId) {
        requestHeaders['Content-Type'] = 'application/json';
        requestBody = JSON.stringify({
          items: [
            { id: Number(mainVariantId), quantity: 1, properties: { _legion_pairing: '10-percent-pair' } },
            { id: Number(pairVariantId), quantity: 1, properties: { _legion_pairing: '10-percent-pair' } }
          ]
        });
      }
      const response = await fetch(`${window.themeRoutes.cartAdd}.js`, {
        method: 'POST',
        headers: requestHeaders,
        body: requestBody
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetchCart();
      renderCart(cart);
      animateProductToCart(sourceUrl, sourceRect);
      showCartToast(productKind, cart.item_count);
      if (popup) popup.close();
      if (isPrimaryProductAdd && !isPair && pairing && !pairing.hidden && typeof pairing.show === 'function') {
        window.setTimeout(() => {
          if (!pairing.open && !pairing.hidden) pairing.show();
        }, 850);
      }
    } catch (error) {
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (button) button.disabled = false;
    }
  });

  const syncAnnouncementStickyOffset = () => {
    const visibleAnnouncement = Array.from(document.querySelectorAll('[data-announcement-bar]')).find((bar) => !bar.hidden);
    const height = visibleAnnouncement ? visibleAnnouncement.getBoundingClientRect().height : 0;
    document.documentElement.classList.toggle('announcement-active', Boolean(visibleAnnouncement));
    document.documentElement.style.setProperty('--announcement-sticky-height', `${height}px`);
  };
  syncAnnouncementStickyOffset();
  window.addEventListener('resize', syncAnnouncementStickyOffset, { passive: true });

  document.querySelectorAll('[data-countdown-end]').forEach((countdown) => {
    const end = new Date(countdown.dataset.countdownEnd).getTime();
    const activeHours = Math.max(1, Number(countdown.dataset.countdownActiveHours) || 24);
    const cooldownHours = Math.max(1, Number(countdown.dataset.countdownCooldownHours) || 2);
    const activeDuration = activeHours * 3600000;
    const cooldownDuration = cooldownHours * 3600000;
    const cycleDuration = activeDuration + cooldownDuration;
    const cycleStart = end - activeDuration;
    const announcement = countdown.closest('[data-announcement-bar]');
    if (!Number.isFinite(end) || !Number.isFinite(cycleStart)) {
      countdown.hidden = true;
      return;
    }
    const update = () => {
      const now = Date.now();
      if (now < cycleStart) {
        announcement?.setAttribute('hidden', '');
        document.documentElement.classList.add('sale-window-paused');
        syncAnnouncementStickyOffset();
        return;
      }
      const cyclePosition = (now - cycleStart) % cycleDuration;
      const isPaused = cyclePosition >= activeDuration;
      announcement?.toggleAttribute('hidden', isPaused);
      document.documentElement.classList.toggle('sale-window-paused', isPaused);
      syncAnnouncementStickyOffset();
      if (isPaused) return;
      const distance = activeDuration - cyclePosition;
      const values = {
        days: 0,
        hours: Math.floor(distance / 3600000),
        minutes: Math.floor((distance / 60000) % 60),
        seconds: Math.floor((distance / 1000) % 60)
      };
      Object.entries(values).forEach(([key, value]) => {
        const output = countdown.querySelector(`[data-countdown-${key}]`);
        if (output) output.textContent = String(value).padStart(2, '0');
      });
    };
    update();
    window.setInterval(update, 1000);
  });
  } catch(e) { console.error(e); }
})();

})();
